import { render, staticRenderFns } from "./LgxDragAndDropRenderer.vue?vue&type=template&id=730af373&"
import script from "./LgxDragAndDropRenderer.vue?vue&type=script&lang=js&"
export * from "./LgxDragAndDropRenderer.vue?vue&type=script&lang=js&"
import style0 from "./LgxDragAndDropRenderer.vue?vue&type=style&index=0&id=730af373&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports